// extracted by mini-css-extract-plugin
export default {"icon":"setlink_icon__jVrcO","action":"setlink_action__w5peV","part":"setlink_part__dKqj8","call":"setlink_call__5-96x","form":"setlink_form__dVXhA"};